import { render, staticRenderFns } from "./index1.vue?vue&type=template&id=5c65e3a3&scoped=true&"
import script from "./index1.vue?vue&type=script&lang=js&"
export * from "./index1.vue?vue&type=script&lang=js&"
import style1 from "./index1.vue?vue&type=style&index=1&lang=less&"
import style2 from "./index1.vue?vue&type=style&index=2&id=5c65e3a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c65e3a3",
  null
  
)

export default component.exports